import FileUpload from './FileUploader.vue';

export { FileUpload };
